import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import { get, post } from "../../../helpers/api_helper";
import {
  GET_CategoryTypes,
  POST_CategoryDelete,
  POST_CategoryExport,
  POST_CategoryInsert,
  POST_CategoryStatusUpdate,
  POST_CategoryUpdate,
  POST_GetCategoryByID,
  POST_GetCategoryListByCategoryType,
} from "../../../helpers/url_helper";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
// import swal from "sweetalert";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  capitalizeString,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const Categories = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const [categoryTypeList, setCategoryTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);

  const [categoryType, setCategoryType] = useState(1);
  const [categoryTypeName, setCategoryTypeName] = useState("Country");
  const [parentCategoryTypeName, setParentCategoryTypeName] =
    useState("Country");

  const [categoryModal, setCategoryModal] = useState(false);
  const [parentCategoryOptions, setParentCategoryOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Search: "",
      Status: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: { Search, Status },
  } = formikFilter;

  const get_CategoryTypes = async () => {
    setIsLoading(true);
    await get(GET_CategoryTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          if (AuthUser?.LicenseTypeID == 5) {
            /* 'Customer Review' Category Type is not required when license type is 5 - Quick Report */
            setCategoryTypeList(
              response?.List?.filter((x) => x.CategoryType != 7)
            );
          } else {
            setCategoryTypeList(response?.List);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    get_CategoryTypes();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    formikFilter.resetForm();
    //getData();
    if (sortBy != "") {
      setSortBy("");
    } else {
      getData();
    }
    if (categoryType == 2) {
      /*categoryType == 2 - State */
      loadParentCategoryDDL(1); //load Country
    } else if (categoryType == 3) {
      /*categoryType == 3 - City */
      loadParentCategoryDDL(2); //load State
    }
  }, [categoryType]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      CategoryType: categoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetCategoryListByCategoryType, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCategoryList(response?.List);
        setIsLoading(false);

        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      CategoryType: categoryType,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_CategoryExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadParentCategoryDDL = async (type) => {
    setIsLoading(true);

    let payload = {
      CurrentPage: 1,
      PageSize: 5000,
      Search: "",
      Sorting: "",
      Status: 1,
      CategoryType: type,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };

    await post(POST_GetCategoryListByCategoryType, payload)
      .then((response) => {
        setParentCategoryOptions(
          response?.List?.filter((x) => x.IsActive == true)?.map((item) => ({
            label: item.CategoryName,
            value: item.CategoryID,
          }))
        );

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    CategoryID: Yup.number(),
    CategoryType: Yup.number(),
    CategoryName: Yup.string()
      .trim()
      .required(`${categoryTypeName} is required field`),
    ParentCategoryID: Yup.string().when(
      "CategoryType",
      ([CategoryType], schema) => {
        /* CategoryType: 2 = "State", CategoryType: 3 = "City" */
        if (CategoryType == 2 || CategoryType == 3)
          return Yup.string().required(
            `${parentCategoryTypeName} is required field`
          );
        return schema;
      }
    ),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CategoryID: 0,
      CategoryType: categoryType,
      CategoryName: "",
      ParentCategoryID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);

    let payload = {
      CategoryID: values.CategoryID ? values.CategoryID : 0,
      CategoryType: categoryType,
      CategoryName: values.CategoryName.trim(),
      ParentCategoryID: values.ParentCategoryID ? values.ParentCategoryID : 0,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      values.CategoryID > 0 ? POST_CategoryUpdate : POST_CategoryInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response.IsSuccess) {
          //  swal("Success!", response.Message, "success");
          successMessage(response?.Message);
          formik.resetForm();
          getData(1, currentSizePerPage);
          if (values.CategoryID > 0) {
            setCategoryModal(false);
          }
        } else {
          //swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function add_category() {
    formik.resetForm();
    formik.setFieldValue("CategoryType", categoryType);

    /*categoryType == 2 - State | categoryType == 3 - City*/
    if (categoryType == 2 || categoryType == 3) {
      /*select the value when there is only one option while insert only*/
      if (parentCategoryOptions?.length == 1) {
        formik.setFieldValue(
          "ParentCategoryID",
          parentCategoryOptions[0].value
        );
      }
    }

    setCategoryModal(true);
    //inputRef.current.focus();
  }

  const get_CategoryByID = async (ID) => {
    setIsLoading(true);
    await post(POST_GetCategoryByID, { CategoryID: ID })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.resetForm();
          formik.setValues({
            CategoryID: ID,
            CategoryType: categoryType,
            CategoryName: response.CategoryName,
            ParentCategoryID: response.ParentCategoryID,
          });
          if (
            parentCategoryOptions?.filter(
              (x) => x.value == response.ParentCategoryID
            )?.length == 0
          ) {
            formik.setFieldValue("ParentCategoryID", "");
          }
          setCategoryModal(true);
        } else {
          //swal("Error!", response.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Categories</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    //setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i>Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 7 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="#"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => add_category()}
                  >
                    <i className="fa-solid fa-plus"></i> Add {categoryTypeName}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <Row className="ps-1 me-0">
                <Col lg={2} className="p-1">
                  <div className="basic-list-group">
                    <ListGroup as="ul" style={{ borderRadius: "0" }}>
                      {categoryTypeList?.map((list, i) => (
                        <Fragment key={i}>
                          <ListGroup.Item
                            as="li"
                            style={{
                              cursor: "pointer",
                              padding: "0.67rem 1rem",
                            }}
                            className={
                              list.CategoryType === categoryType ? "active" : ""
                            }
                            onClick={() => {
                              setCategoryTypeName(list.Name);
                              setCategoryType(list.CategoryType);
                              setParentCategoryTypeName(
                                list.CategoryType == 2
                                  ? "Country"
                                  : list.CategoryType == 3
                                  ? "State"
                                  : ""
                              );
                              formik.setFieldValue(
                                "CategoryType",
                                list.CategoryType
                              );
                              formikFilter.setValues({
                                Status: -1,
                                Search: "",
                              });
                            }}
                          >
                            {list.Name}
                          </ListGroup.Item>
                        </Fragment>
                      ))}
                    </ListGroup>
                  </div>
                </Col>
                <Col lg={10} className="p-1">
                  {showFilter ? (
                    <div>
                      <FormikProvider value={formikFilter}>
                        <Form onSubmit={formikFilter.handleSubmit}>
                          <Row className="me-0">
                            <Col lg={3}>
                              <Field
                                label="Search"
                                name="Search"
                                placeholder={"Search here..."}
                                component={CustomInput}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label="Status"
                                name="Status"
                                placeholder={"Select Status"}
                                options={statusOptions}
                                component={CustomSelect}
                                isClearable={false}
                              />
                            </Col>
                            <Col lg={3}>
                              <label className="mb-1">&nbsp;</label>
                              <div className="d-flex">
                                <div className="d-lg-block">
                                  <Link
                                    // className="btn btn-primary btn-sm mb-1"
                                    className="btn btn-primary btn-sm"
                                    onClick={(e) => {
                                      getData();
                                    }}
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    Search
                                  </Link>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </FormikProvider>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    id="Categories-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="projects-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="6%"></th>
                          <th
                            style={
                              categoryType == 2 || categoryType == 3
                                ? {
                                    width: "52%",
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }
                                : {
                                    width: "94%",
                                    textAlign: "left",
                                    cursor: "pointer",
                                  }
                            }
                            onClick={() => {
                              handleClickSorting("CategoryName");
                            }}
                          >
                            {categoryTypeName}
                            <span className="ml-1">
                              {sortBy == "CategoryName" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                          {categoryType == 2 ? (
                            <th
                              style={{
                                width: "52%",
                                textAlign: "left",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickSorting("ParentCategoryName");
                              }}
                            >
                              Country
                              <span className="ml-1">
                                {sortBy == "ParentCategoryName" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                          ) : (
                            ""
                          )}
                          {categoryType == 3 ? (
                            <th
                              style={{
                                width: "50%",
                                textAlign: "left",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                handleClickSorting("ParentCategoryName");
                              }}
                            >
                              State
                              <span className="ml-1">
                                {sortBy == "ParentCategoryName" ? (
                                  orderBy == "desc" ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-14"
                                      style={{ opacity: "0.7" }}
                                    />
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort ms-2 fs-14"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                              </span>
                            </th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {categoryList?.length > 0 ? (
                          categoryList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 7 && x?.IsEdit
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-primary-light me-1"
                                    className="icon-box icon-box-md me-1"
                                    title="Edit"
                                    onClick={() =>
                                      get_CategoryByID(item.CategoryID)
                                    }
                                  >
                                    {SVGICON.EditPrimary}
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 7 && x?.IsActive
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className={`icon-box icon-box-md bg-${
                                    //   item.IsActive == true ? "success" : "danger"
                                    // }-light me-1`}
                                    className={`icon-box icon-box-md me-1`}
                                    title={
                                      item.IsActive == true
                                        ? "Active"
                                        : "Inactive"
                                    }
                                    onClick={() => {
                                      ActiveInactive_Record(
                                        item.IsActive,
                                        POST_CategoryStatusUpdate,
                                        {
                                          CategoryID: item.CategoryID,
                                          IsActive: !item.IsActive,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.CategoryName
                                      );
                                    }}
                                  >
                                    <i
                                      className={`fa fa-circle fs-15 ${
                                        item.IsActive == true
                                          ? "text-success"
                                          : "text-danger"
                                      }`}
                                    ></i>
                                  </Link>
                                ) : (
                                  ""
                                )}
                                {AuthUser?.UserType !== 1 ||
                                formsList?.filter(
                                  (x) => x?.FormID == 7 && x?.IsDelete
                                )?.length > 0 ? (
                                  <Link
                                    to="#"
                                    // className="icon-box icon-box-md bg-danger-light"
                                    className="icon-box icon-box-md me-1"
                                    title="Delete"
                                    onClick={() => {
                                      delete_Record(
                                        POST_CategoryDelete,
                                        {
                                          CategoryID: item.CategoryID,
                                          ModifiedByEncrypted:
                                            AuthUser?.ReferenceIDEncrypt
                                              ? AuthUser?.ReferenceIDEncrypt
                                              : "0",
                                        },
                                        setIsLoading,
                                        fnCallback,
                                        item.CategoryName
                                      );
                                    }}
                                  >
                                    {SVGICON.DeleteDanger}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  verticalAlign: "top",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.CategoryName}
                              </td>
                              {item.ParentCategoryID != 0 ? (
                                <td style={{ textAlign: "left" }}>
                                  {item.ParentCategoryName}
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                      <CustomSizePerPage
                        getData={getData}
                        currentSizePerPage={currentSizePerPage}
                      />
                      <div className="dataTables_info">
                        Showing{" "}
                        {recordCount > 0
                          ? (currentPage - 1) * currentSizePerPage + 1
                          : 0}{" "}
                        to{" "}
                        {recordCount > currentPage * currentSizePerPage
                          ? currentPage * currentSizePerPage
                          : recordCount}{" "}
                        of {recordCount} entries
                      </div>
                      <CustomPaginationButtons
                        totalPages={recordCount / currentSizePerPage}
                        currentPage={currentPage}
                        currentSizePerPage={currentSizePerPage}
                        getData={getData}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Spin>
        <Modal className="fade" show={categoryModal} onHide={setCategoryModal}>
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>{categoryTypeName}</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setCategoryModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    {categoryType == 2 || categoryType == 3 ? (
                      <Col lg={12}>
                        <Field
                          type="text"
                          label={
                            categoryType == 2
                              ? "Country"
                              : categoryType == 3
                              ? "State"
                              : ""
                          }
                          name="ParentCategoryID"
                          placeholder={`Select ${
                            categoryType == 2
                              ? "Country"
                              : categoryType == 3
                              ? "State"
                              : ""
                          }`}
                          options={parentCategoryOptions}
                          component={CustomSelect}
                          required
                          autoFocus
                        />
                      </Col>
                    ) : (
                      ""
                    )}
                    {categoryType == 9 ? (
                      <Col lg={12}>
                        <Field
                          type="text"
                          label={categoryTypeName}
                          name="CategoryName"
                          placeholder={`Enter ${categoryTypeName}`}
                          component={CustomTextArea}
                          rows={5}
                          maxLength={2000}
                          required
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "CategoryName",
                              capitalizeString(e)
                            );
                          }}
                        />
                      </Col>
                    ) : (
                      <Col lg={12}>
                        <Field
                          type="text"
                          label={categoryTypeName}
                          name="CategoryName"
                          placeholder={`Enter ${categoryTypeName}`}
                          component={CustomInput}
                          maxLength={250}
                          required
                          autoFocus
                          onChange={(e) => {
                            formik.setFieldValue(
                              "CategoryName",
                              capitalizeString(e)
                            );
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setCategoryModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default Categories;
